'use client';

import { slugify } from '../Utils/helpers.js';
import { convertDateTime } from '../Utils/time.js';

function convertISOToMillisecond(dateTime) {
    return Date.parse(dateTime) / 1000;
}
var SERVICE_CODE_REFRESH_JOB_CLP_REWARD = 'RJF';
var checkIsNew = function (item) {
    if (item.onlineServiceCode === SERVICE_CODE_REFRESH_JOB_CLP_REWARD) {
        return false;
    }
    return convertDateTime(new Date(item.onlineOn || ''), 7) === convertDateTime(Date.now(), 7);
};
var buildCompanyUrl = function (companyId, companyName, langCode) {
    var companyNameStr = slugify(companyName);
    var prefixCompanyPath = langCode === 'vi' ? 'nha-tuyen-dung' : 'companies';
    return "/".concat(prefixCompanyPath, "/").concat(companyNameStr, "-c").concat(companyId);
};
var formatedJob = function (job) {
    var categoryVIs = [];
    var categoryIds = [];
    var categories = [];
    var locationIds = [];
    var locationVIs = [];
    var locations = [];
    var services = [];
    if (job.industries !== null && job.industries !== undefined) {
        job.industries.map(function (industry) {
            categoryVIs.push(industry.industryNameVI);
            categoryIds.push(industry.industryId);
            categories.push(industry.industryName);
        });
    }
    if (job.workingLocations !== null && job.workingLocations !== undefined) {
        job.workingLocations.map(function (wl) {
            locationIds.push(wl.workingLocationId);
            if (locationVIs && locationVIs.indexOf(wl.cityNameVI) < 0) {
                locationVIs.push(wl.cityNameVI);
            }
            if (locations && locations.indexOf(wl.cityName) < 0) {
                locations.push(wl.cityName);
            }
        });
    }
    if (job.services !== null && job.services !== undefined) {
        job.services.map(function (service) {
            services.push(service.serviceCode);
        });
    }
    return {
        categoryVIs: categoryVIs,
        categoryIds: categoryIds,
        categories: categories,
        locationVIs: locationVIs,
        locationIds: locationIds,
        locations: locations,
        serviceCode: services,
        isPremium: !job.simpleServices ? false : job.simpleServices.includes('isPremium'),
        isHeadhuntJob: !job.simpleServices ? false : job.simpleServices.includes('isHeadhunt'),
        /**
         * VNW-18143 Add service Urgent Job -M
         *
         * Because UJ and UJ-M are same rule search on Web
         *
         * @author Thai Tran
         * @since Otc 6, 2022
         */
        isUrgentJob: job.isUrgentJob,
        isTopManagementJob: !services ? false : services.includes('TMJ'),
        isPriorityJob: !services ? false : services.includes('PJ')
    };
};

export { buildCompanyUrl, checkIsNew, convertISOToMillisecond, formatedJob };
//# sourceMappingURL=utils.js.map
